import React from 'react';
import { View } from 'react-native';

import { adminTableStyles as styles } from './adminTableStyles';

export interface AdminTableProps {
  testID: string;
  accessibilityLabel?: string;
  pager?: React.ReactNode;
  children: React.ReactNode;
}

export const AdminTable: React.FC<AdminTableProps> = ({
  testID,
  accessibilityLabel,
  pager,
  children,
}) => (
  <View style={styles.frame} testID={`${testID}-frame`}>
    <View
      style={styles.table}
      testID={testID}
      accessibilityLabel={accessibilityLabel}
    >
      {children}
    </View>
    {pager}
  </View>
);
